/* ============================================
   HOME COMPONENT - Dashboard Overview
   ============================================ */

import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useWebSocket } from '../hooks/useWebSocket';

export default function Home() {
  const { user } = useAuth();
  const wsUrl = process.env.REACT_APP_WS_URL || '';
  const { status, lastMessage } = useWebSocket(wsUrl);

  const stats = [
    { label: 'Server Status', value: status === 'connected' ? 'Online' : 'Offline', status },
    { label: 'Admin Role', value: user?.role || 'N/A', status: 'connected' },
    { label: 'Session', value: 'Active', status: 'connected' },
    { label: 'WebSocket', value: status === 'connected' ? 'Live' : 'Disconnected', status },
  ];

  return (
    <div className="home-page">
      <header className="page-header">
        <h1>Dashboard</h1>
        <p>Welcome back, <strong>{user?.displayName || user?.username}</strong></p>
      </header>

      <div className="stats-grid">
        {stats.map((s, i) => (
          <div className="stat-card" key={i}>
            <div className={`stat-indicator ${s.status}`} />
            <div className="stat-label">{s.label}</div>
            <div className="stat-value">{s.value}</div>
          </div>
        ))}
      </div>

      <div className="panel">
        <h2 className="panel-title">System Logs</h2>
        <div className="log-box">
          {lastMessage ? (
            <pre>{JSON.stringify(lastMessage, null, 2)}</pre>
          ) : (
            <p className="log-empty">Waiting for WebSocket messages...</p>
          )}
        </div>
      </div>

      <div className="panel">
        <h2 className="panel-title">Quick Actions</h2>
        <div className="actions-row">
          <button className="action-btn">Restart Server</button>
          <button className="action-btn">Clear Cache</button>
          <button className="action-btn">Backup Now</button>
          <button className="action-btn">View Logs</button>
        </div>
      </div>

      <style>{`
        .home-page {
          padding: 30px;
        }
        .page-header {
          margin-bottom: 25px;
        }
        .page-header h1 {
          font-size: 22px;
          color: #222;
          margin-bottom: 6px;
        }
        .page-header p {
          color: #666;
          font-size: 13px;
        }
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 15px;
          margin-bottom: 25px;
        }
        .stat-card {
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 4px;
          padding: 18px;
          position: relative;
          overflow: hidden;
        }
        .stat-indicator {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
        }
        .stat-indicator.connected {
          background: #2ecc71;
        }
        .stat-indicator.disconnected {
          background: #e74c3c;
        }
        .stat-indicator.error {
          background: #f39c12;
        }
        .stat-label {
          font-size: 11px;
          color: #888;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 6px;
        }
        .stat-value {
          font-size: 18px;
          font-weight: bold;
          color: #222;
        }
        .panel {
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 4px;
          padding: 20px;
          margin-bottom: 20px;
        }
        .panel-title {
          font-size: 14px;
          color: #333;
          margin-bottom: 15px;
          padding-bottom: 10px;
          border-bottom: 1px solid #eee;
        }
        .log-box {
          background: #1e1e1e;
          color: #0f0;
          padding: 15px;
          border-radius: 3px;
          font-family: 'Courier New', monospace;
          font-size: 12px;
          min-height: 120px;
          overflow-x: auto;
        }
        .log-box pre {
          margin: 0;
          white-space: pre-wrap;
          word-break: break-word;
        }
        .log-empty {
          color: #666;
          margin: 0;
        }
        .actions-row {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
        }
        .action-btn {
          padding: 8px 18px;
          background: linear-gradient(to bottom, #ff7a3d 0%, #e05216 100%);
          border: 1px solid #c33d06;
          border-radius: 3px;
          color: #fff;
          font-size: 12px;
          font-weight: bold;
          cursor: pointer;
          transition: opacity 0.2s;
        }
        .action-btn:hover {
          opacity: 0.9;
        }
        .action-btn:active {
          background: #d6470d;
        }
      `}</style>
    </div>
  );
}
